import React from 'react'
import './picture.scss'
import useBemClass from '@/utils/hooks/useBEMClass'
import { Expaned } from '@/components/layout/layout'
import { useRequest } from 'ahooks'
import { IMaterials, MaterialsList } from '../../goods-manage/components/material-library/choose-material-dialog'
import { IPagination } from '@/model/types/common'
import { $post } from '@/api'
import Table, { ColumnsType } from 'antd/lib/table'
import { materialStore } from '../store'
import { observer } from 'mobx-react'
import { AutoResizer, WithScrollLoad } from '@/utils/utils-widget'
import { materialColumns } from './picture'
import { downloadImg } from '@/utils'
import { getQiniuImgUrl } from '@/config/qiniu'

const InternalPicturematerial = observer(() => {
    const cls = useBemClass('picture-material')

    const requestHandle = useRequest<
        MaterialsList,
        {
            materials: IMaterials[]
            pagination: IPagination
        }
    >(
        val =>
            $post({
                url: '/material/getmaterials',
                params: {
                    limit: 20,
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                    status: 1,
                    types: [3],
                    keyword: materialStore.keyWord || void 0,
                },
            }),
        {
            isNoMore: data => {
                if (data?.pagination) {
                    return data?.pagination.page === data?.pagination.page_count
                } else {
                    return false
                }
            },
            loadMore: true,
            formatResult: data => {
                return {
                    list: data.materials,
                    pagination: data.pagination,
                }
            },
            refreshDeps: [materialStore.keyWord, materialStore.materialStatus],
        },
    )

    const columns: ColumnsType<IMaterials> = [
        {
            title: '操作',
            key: 'action',
            width: 74,
            align: 'center',
            render: (value, record) => (
                <div
                    className="action"
                    onClick={() => {
                        downloadImg(getQiniuImgUrl(record.url), record.name)
                    }}
                >
                    下载
                </div>
            ),
        },
    ]

    return (
        <Expaned className={cls()}>
            <Expaned data-row className={cls('content')}>
                <AutoResizer>
                    {({ height }) => {
                        return (
                            <WithScrollLoad data-expaned data-overflow-hidden scrollloadhandle={requestHandle}>
                                <Table
                                    rowKey={record => record.id}
                                    loading={requestHandle.loading || requestHandle.loadingMore || void 0}
                                    bordered
                                    pagination={false}
                                    columns={[...materialColumns, ...columns]}
                                    dataSource={requestHandle.data?.list}
                                    scroll={{ x: 'max-content', y: height - 50 }}
                                />
                            </WithScrollLoad>
                        )
                    }}
                </AutoResizer>
            </Expaned>
        </Expaned>
    )
})

export default InternalPicturematerial
